import edit from "../edit";
import metadata from "./block.json";

const __ = Drupal.t;

const { category, attributes, supports } = metadata;

const icon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		x="0px"
		y="0px"
		width="250"
		height="250"
		viewBox="0 0 50 50"
	>
		<title id="pie-chart-title">{__("Radar Chart")}</title>
		<path d="M 25 0 C 23.9375 0 23.066406 0.828125 23 1.875 L 12.09375 7.3125 C 11.78125 7.109375 11.398438 7 11 7 C 9.894531 7 9 7.894531 9 9 C 9 9.355469 9.117188 9.679688 9.28125 9.96875 L 2.0625 22 C 2.042969 22 2.019531 22 2 22 C 0.894531 22 0 22.894531 0 24 C 0 25.105469 0.894531 26 2 26 C 2.355469 26 2.679688 25.882813 2.96875 25.71875 L 15 32.9375 C 15 32.957031 15 32.980469 15 33 C 15 34.082031 15.863281 34.964844 16.9375 35 L 23.3125 46.9375 C 23.121094 47.246094 23 47.609375 23 48 C 23 49.105469 23.894531 50 25 50 C 26.09375 50 26.984375 49.121094 27 48.03125 L 40 40.71875 C 40.292969 40.890625 40.636719 41 41 41 C 42.105469 41 43 40.105469 43 39 C 43 38.554688 42.839844 38.144531 42.59375 37.8125 L 48.21875 24.96875 C 49.21875 24.859375 50 24.03125 50 23 C 50 21.96875 49.21875 21.140625 48.21875 21.03125 L 43.59375 10.1875 C 43.839844 9.855469 44 9.445313 44 9 C 44 7.894531 43.105469 7 42 7 C 41.554688 7 41.144531 7.160156 40.8125 7.40625 L 26.96875 1.71875 C 26.832031 0.746094 26.007813 0 25 0 Z M 26.21875 3.59375 L 40.03125 9.28125 C 40.15625 10.171875 40.855469 10.855469 41.75 10.96875 L 46.40625 21.8125 C 46.160156 22.144531 46 22.554688 46 23 C 46 23.445313 46.160156 23.855469 46.40625 24.1875 L 40.78125 37.03125 C 39.789063 37.140625 39.015625 37.953125 39 38.96875 L 26 46.28125 C 25.722656 46.121094 25.402344 46.011719 25.0625 46 L 18.6875 34.0625 C 18.878906 33.753906 19 33.390625 19 33 C 19 31.894531 18.105469 31 17 31 C 16.644531 31 16.320313 31.117188 16.03125 31.28125 L 4 24.0625 C 4 24.042969 4 24.019531 4 24 C 4 23.636719 3.890625 23.292969 3.71875 23 L 10.9375 11 C 10.957031 11 10.980469 11 11 11 C 12.0625 11 12.933594 10.171875 13 9.125 L 23.875 3.65625 C 24.195313 3.871094 24.585938 4 25 4 C 25.457031 4 25.882813 3.851563 26.21875 3.59375 Z" />
	</svg>
);

const settings = {
	...metadata,
	title: __("Radar Chart"),
	description: __(
		"Display your data in a Radar Chart. Ideal for single and multiple datasets.",
	),
	icon,
	category,
	supports,
	attributes,
	edit,
	save: () => null,
};

export { settings as radar };
